<script setup lang="ts">
import type {UserMinimal} from "~/repository/types";

defineProps<{
  repostedBy: UserMinimal
}>()

const {user} = useAuthStore();
</script>

<template>
  <NuxtLink
      :to="{ name: 'username', params: { username: repostedBy.username } }"
      class="w-auto self-baseline pl-2 pr-3 py-1.5 flex items-center justify-center bg-gray-light backdrop-blur-sm rounded-sm text-xs hover:bg-gray transition-colors duration-200">
    <UserAvatar class="w-5 h-5 mr-2 rounded-full" :user="repostedBy"/>
    <span>Podane dalej przez </span>
    <span class="font-bold ml-1"> {{ user && user.id == repostedBy.id ? 'Ciebie' : repostedBy.username }}</span>
  </NuxtLink>
</template>